var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
// '#query-hooks' is imported by direct path: its barrel would close the context <-> query-hooks cycle (see CLAUDE.md).
import { useMemo } from 'react';
import { useCurrentProfile } from '#query-hooks/queries/account/useCurrentProfile';
import { AuthProviderContext } from './AuthProviderContext';
import { useHandleAuthBroadcast } from './hooks';
export const AuthProvider = ({ children }) => {
    _react_refresh_temp_2();
    const { query: { data, isLoading }, } = useCurrentProfile({
        enabled: true,
    });
    useHandleAuthBroadcast();
    const value = useMemo(() => ({
        currentUser: data,
        isLoadingCurrentUser: isLoading,
    }), [data, isLoading]);
    return (_jsx(AuthProviderContext.Provider, { value: value, children: children }));
};
_react_refresh_temp_1 = AuthProvider;
$RefreshReg$(_react_refresh_temp_1, "AuthProvider");
_react_refresh_temp_2(AuthProvider, "fpCT4Y69d3vqFSjGN2+yTYmD1CY=", false, () => [useCurrentProfile, useHandleAuthBroadcast]);
